import { Api } from 'utils';

class UserService {

	static admin = {
		get: async (params?: any) => Api.createResponse('admin/users',params),
		update: async (params?: any) => Api.createResponse('admin/users/update',params),
		registerAdmin: async (params?: any) => Api.createResponse('auth/register-admin',params),
		delete: async (params?: any) => Api.createResponse('admin/users/delete',params),
		deletePlanUser: async (params?: any) => Api.createResponse('admin/users/delete-plan-user',params),
		getPlanList: async (params?: any) => Api.createResponse('admin/users/plan-list',params),
	}

}

export default UserService;